// index.js or main file
import React, {useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Studio from './admin/pages/studio/studio';
import LiveHost from './admin/pages/liveHost/liveHost';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import ThankYou from './pages/thankyou/thankyou';
import Feedback from './pages/feedback/feedback';
import Leaderboard from './pages/leaderboard/Leaderboard';
import USER from './pages/dddUI/user';
import ThemeUpdate from './admin/pages/themeupdate/themeupdate';
import JoinLobby from './pages/JoinLobby/JoinLobby';
import TeamRegistration from './pages/TeamRegistration/TeamRegistration';
import WarCryRecording from './pages/WarCryRecording/WarCryRecording';
import Instructions from './pages/Instructions/Instructions';
import WaitingRoom from './pages/WaitingRoom/WaitingRoom';
import ManagerDashboard from './pages/ManagerDashboard/ManagerDashboard';
import UserGame from './pages/UserGame/UserGame';
import CheckpointGame from './pages/CheckpointGame/CheckpointGame';





function App() {
  // usePageBackground();

   return (
    <Provider store={store}>
      <Routes>
        {/* Admin routes (no DDDUI wrapper) */}
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Studio /></Admin>} />
          <Route path="live" element={<Admin><LiveHost /></Admin>} />
          <Route path="themeupdate" element={<Admin><ThemeUpdate /></Admin>} />
          <Route path="superadmin" element={<LoginPage/>} />
        </Route>

        {/* Public routes wrapped with DDDUI */}
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/join" element={<JoinLobby />} />
              <Route path="/team-registration" element={<TeamRegistration />} />
              <Route path="/war-cry" element={<WarCryRecording />} />
              <Route path="/instructions" element={<Instructions />} />
              <Route path="/waiting-room" element={<WaitingRoom />} />
              <Route path="/manager-dashboard" element={<ManagerDashboard />} />
              <Route path="/usergame" element={<UserGame />} />
              <Route path="/game" element={<CheckpointGame />} />
              <Route path="/leaderboard" element={<Leaderboard/>} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/thankyou" element={<ThankYou/>} />
              <Route path="/feedback" element={<Feedback/>} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
